import { IconButton, Menu, MenuItem } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import React from "react";
import { useHistory } from "react-router-dom";
import useApi from "../../../../../hooks/api";
import useAuth from "../../../../../hooks/auth";

const UserMenu = () => {
  const { del } = useApi();
  const { deleteAuth } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const history = useHistory();

  const handleLogout = () => {
    return del("/auth/sign_out")
      .then(() => {
        deleteAuth();
        window.location.href = "/";
      })
      .catch(() => {
        alert(
          "Não conseguimos processar o comando. Favor, limpar o cache do seu navegador, recarregar a página e tentar novamente."
        );
      });
  };

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const gotoEditProfile = () => history.push("/usuario/meu_perfil");
  const gotoConfig = () => history.push("/usuario/config");

  return (
    <div className="nb-user-menu">
      <IconButton
        color="inherit"
        className="nb-user-dropdown dropdown-toggle no-margin"
        aria-controls="user-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disableFocusRipple={true}
        disableRipple={true}
        edge="end"
      >
        <AccountCircleIcon />
      </IconButton>

      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        keepMounted
        onClose={handleClose}
      >
        <MenuItem onClick={gotoEditProfile}>Meu perfil</MenuItem>
        <MenuItem onClick={gotoConfig}>Configurações</MenuItem>
        <MenuItem onClick={handleLogout}>Sair</MenuItem>
      </Menu>
    </div>
  );
};

export default UserMenu;
